import { Alert, Button, Paper, Stack, Typography } from "@mui/material";
import { HttpStatusCode } from "axios";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import CenterScreen from "../../../components/wrappers/CenterScreen";
import { SnackbarContext } from "../../../contexts/Snackbar";
import { RESEND_VERIFICATION_EMAIL } from "../../../enums/ApiPaths";
import authApi from "../../../utils/api/authApi";
import AuthFooter from "../login/component/AuthFooter";

export default function ResendVerificationMailPage() {
  const { state } = useLocation();
  const { t } = useTranslation();
  const { handleSnackbar } = React.useContext(SnackbarContext);

  async function resendEmail() {
    try {
      const res = await authApi.post(
        `${RESEND_VERIFICATION_EMAIL}?email=${state.email}`
      );
      if (res.status === HttpStatusCode.Ok) {
        handleSnackbar("VerificationResend", "success");
      }
    } catch (error) {
      handleSnackbar(error?.response?.data || t("SomethingWentWrong"), "error");
    }
  }

  return (
    <Fragment>
      <CenterScreen minHeight="78vh">
        <Paper sx={{ p: { xs: 2, md: 3 }, width: "100%", maxWidth: 450 }}>
          <Stack spacing={2} alignItems="center">
            <Alert severity="info" sx={{ textAlign: "center", width: "100%" }}>
              {t("SuccessfulRegistrationUserMessage")}
            </Alert>
            <Typography
              variant="body1"
              sx={{ textAlign: "center", wordBreak: "break-word" }}
            >
              <strong>{t("Email")}:</strong> {state.email}
            </Typography>
            <Button
              variant="contained"
              onClick={resendEmail}
              fullWidth
              sx={{ maxWidth: 300 }}
              data-testid="auth.signup.resend-verification-email-button"
            >
              {t("ResendVerificationEmail")}
            </Button>
          </Stack>
        </Paper>
      </CenterScreen>
      <AuthFooter />
    </Fragment>
  );
}
